<template>
  <div>
    <img src="@/assets/img/campaign/20250521_manavisfesta_01.jpg" /><br>
    <img src="@/assets/img/campaign/20250521_manavisfesta_02.jpg" style="margin-top: 5px;" />
  </div>
</template>


<style scoped>
</style>

<script>
</script>